import React, { useEffect, useState } from 'react';
import DashBoardChart from './Components/DashBoardChart';
import {
	getDashBoardPie,
	getDashBoardWaterFall,
	getProgramSavingsMainTable,
	getProgramSavingsMicroMacroTable,
	getVendorCount,
	getVendorEliminationReport,
	getVendorReductionReport,
} from 'utils/apiRequests';
import {
	combinePieData,
	combineWaterFallData,
	convertMicroMacroData,
	GL_ACCOUNT_MASTER_DATA,
	PIE_DATA,
	PROGRAMS_SAVINGS_DASHBOARD,
	PROGRAMS_SAVINGS_MICRO_MACRO_DASHBOARD,
	VENDOR_COUNT,
	VENDOR_ELIMINATION_REPORT,
	WATERFALL_DATA,
} from 'SpendController/utils';
import NavBar from './Components/NavBar';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import { Container } from 'SpendController/Components/Components.styles';
import {
	CenteredContainer,
	NavDiv,
	SearchWrapper,
} from './FinanceReport.styles';
import ProgramSavings from './Components/ProgramSavingsDasBoard/ProgramSavings';
import VendorEliminationReport from './Components/VendorEliminationReport/VendorEliminationReport';
import GLAccountMaster from './Components/GLAccountMaster/GLAccountMaster';
import { SearchInput } from 'components/SearchInput';
import { TooltipIcon } from 'BudgetTracker/HeaderSummary/HeaderSummary.styles';
import { Tooltip } from 'react-tippy';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import { TooltipContent } from 'BudgetTracker/SecondaryNav/SecondaryNav.styles';
import { spendFormatter } from 'utils/filterNames';

function FinanceReport() {
	const [waterfallData, setWaterFallData] = useState(WATERFALL_DATA);
	const [pieData, setPieData] = useState({
		chartData: PIE_DATA,
		kpiData: [0, 0],
	});
	const [vendorCountData, setVendorCountData] = useState(VENDOR_COUNT);
	const [isLoading, setLoading] = useState(false);
	const [programSavingsDashboard, setProgramSavingsDashboard] = useState({
		columnDefs: PROGRAMS_SAVINGS_DASHBOARD,
		rowData: [],
	});
	const [
		programSavingsMicroMacroData,
		setProgramSavingsMicroMacroData,
	] = useState({
		columnDefs: PROGRAMS_SAVINGS_MICRO_MACRO_DASHBOARD,
		rowData: [],
	});
	const [vendorElimationReportData, setVendorElimationReportData] = useState({
		columnDefs: VENDOR_ELIMINATION_REPORT,
		rowData: [],
	});
	const [vendorReductionReportData, setVendorReductionReportData] = useState({
		columnDefs: VENDOR_ELIMINATION_REPORT,
		rowData: [],
	});
	const [glAccountMasterData] = useState(GL_ACCOUNT_MASTER_DATA);
	const [navNo, setNavNumber] = useState(0);
	const { searchOptions } = useSpendControllerFiltersContext();
	const [selectedSearchOption, setSelectedSearchOption] = useState(null);
	useEffect(
		() => {
			getDashBoardChartData();
			getProgramSavingsData();
			handleVendorEliminationData();
			handleVendorReductionData();
			// eslint-disable-next-line react-hooks/exhaustive-deps
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedSearchOption]
	);

	const getDashBoardChartData = async () => {
		setLoading(true);
		const waterFallRespone = await getDashBoardWaterFall(selectedSearchOption);
		const pieResponse = await getDashBoardPie(selectedSearchOption);
		const vendorCountResponse = await getVendorCount(selectedSearchOption);

		const formattedWaterFallData = combineWaterFallData(
			waterFallRespone.data,
			waterfallData
		);
		const formattedPieData = combinePieData(
			pieResponse.data,
			pieData.chartData
		);

		const initialSpend =
			formattedWaterFallData[formattedWaterFallData.length - 1].y;
		const sumSaving = Object.values(pieResponse.data).reduce(
			(acc, value) => acc + value,
			0
		);

		const formattedSavingOpportunity = (sumSaving / initialSpend) * 100;
		setWaterFallData(formattedWaterFallData);
		setPieData({
			chartData: formattedPieData,
			kpiData: [spendFormatter(sumSaving, true), formattedSavingOpportunity],
		});
		setVendorCountData(vendorCountResponse.data);
	};
	const getProgramSavingsData = async () => {
		const programSavingsMainDataResponse = await getProgramSavingsMainTable(
			selectedSearchOption
		);
		setProgramSavingsDashboard(prevstate => ({
			...prevstate,
			rowData: programSavingsMainDataResponse.data,
		}));
		const programSavingsMicroMacroDataResponse = await getProgramSavingsMicroMacroTable(
			selectedSearchOption
		);
		setProgramSavingsMicroMacroData(prevstate => ({
			...prevstate,
			rowData: convertMicroMacroData(programSavingsMicroMacroDataResponse.data),
		}));
		setLoading(false);
	};
	const handleVendorEliminationData = async () => {
		const vendorEliminationResponse = await getVendorEliminationReport(
			selectedSearchOption
		);
		setVendorElimationReportData(prevstate => ({
			...prevstate,
			rowData: vendorEliminationResponse.data,
		}));
	};
	const handleVendorReductionData = async () => {
		const vendorReductionResponse = await getVendorReductionReport(
			selectedSearchOption
		);
		setVendorReductionReportData(prevstate => ({
			...prevstate,
			rowData: vendorReductionResponse.data,
		}));
	};
	const handleNavComponentChange = () => {
		switch (navNo) {
			case 0:
				return (
					<ProgramSavings
						programSavingsMicroMacroData={programSavingsMicroMacroData}
						programSavingsDashboard={programSavingsDashboard}
					/>
				);
			case 1:
				return (
					<VendorEliminationReport
						vendorElimationReportData={vendorElimationReportData}
					/>
				);
			case 2:
				return (
					<VendorEliminationReport
						vendorElimationReportData={vendorReductionReportData}
					/>
				);
			case 3:
				return <GLAccountMaster data={glAccountMasterData} />;
			default:
				return <span />;
		}
	};
	return (
		<>
			<Container>
				<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<SearchWrapper>
						<SearchInput
							placeholder="Search..."
							placement="bottom-end"
							charCount={3}
							maxMatchesNumber={10}
							showIcon
							isSelectable
							isDismissible
							selectedOption={selectedSearchOption}
							options={searchOptions}
							onChange={e => setSelectedSearchOption(e)}
						/>
						<TooltipIcon>
							<Tooltip
								position="bottom"
								animation="fade"
								arrow
								theme="light"
								trigger="click"
								html={
									<TooltipContent>
										Enter Business Unit, Final Category, Entity, Supplier Name
										or Spend Owner, to filter the data in the charts and tables.
									</TooltipContent>
								}
								popperOptions={{
									modifiers: {
										preventOverflow: {
											enabled: true,
											boundariesElement: 'window',
										},
									},
								}}
							>
								<ApIcon
									iconName="outline_info"
									iconColor={colors.grey5}
									iconSize={16}
								/>
							</Tooltip>
						</TooltipIcon>
					</SearchWrapper>
				</div>
				<LoadingSpinner visible={isLoading} message={`Loading`} />
				<DashBoardChart
					waterfallData={waterfallData}
					pieData={pieData.chartData}
					vendorCountData={vendorCountData}
					savingData={pieData.kpiData}
				/>
				<NavDiv>
					<NavBar navNo={navNo} setNavNumber={setNavNumber} />
					<CenteredContainer>{handleNavComponentChange()}</CenteredContainer>
				</NavDiv>
			</Container>;
		</>
	);
}

export default FinanceReport;
